import { render, staticRenderFns } from "./NotificationNavItem.vue?vue&type=template&id=65d0e8c1&scoped=true"
import script from "./NotificationNavItem.vue?vue&type=script&lang=js"
export * from "./NotificationNavItem.vue?vue&type=script&lang=js"
import style0 from "./NotificationNavItem.vue?vue&type=style&index=0&id=65d0e8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0e8c1",
  null
  
)

export default component.exports